import React from 'react';
import ReactGA from 'react-ga';

import { ButtonContainer, Container } from './styles';

interface Props {
  url: string;
}

const LgpdCard = ({ url }: Props) => {
  const handleGaLink = () => {
    ReactGA.outboundLink({ label: 'Link LGPD - Horus' }, () => {
      window.open(url, '_blank');
    });
  };
  return (
    <Container data-cy="lgpd-container">
      <h5 data-cy="lgpd-text">
        Como podemos te mandar benefícios exclusivos e dicas personalizadas?
      </h5>
      <ButtonContainer data-cy="lgpd-button" onClick={() => handleGaLink()}>
        Responder agora
      </ButtonContainer>
    </Container>
  );
};

export default LgpdCard;
